

















import { Receipt } from "@/services/notificacoes-apple.service";
import DataTable, { TableHeader } from "@/shared/components/data-table.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import { dateTimeSeconds } from "@/shared/filters";

@Component({
  components: { DataTable },
  filters: { dateTimeSeconds },
})
export default class UltimosRecibos extends Vue {
  headers: TableHeader[] = [
    { text: "OriginalTransactionId", value: "originalTransactionId" },
    { text: "TransactionId", value: "transactionId" },
    { text: "ProductId", value: "productId" },
    { text: "CancellationDate", value: "cancellationDate" },
    { text: "CancellationReason", value: "cancellationReason" },
    { text: "PurchaseDate", value: "purchaseDate" },
    { text: "OriginalPurchaseDate", value: "originalPurchaseDate" },
    { text: "ExpiresDate", value: "expiresDate" },
    { text: "IsInIntroOfferPeriod", value: "isInIntroOfferPeriod" },
    { text: "IsTrialPeriod", value: "isTrialPeriod" },
    {
      text: "SubscriptionGroupIdentifier",
      value: "subscriptionGroupIdentifier",
    },
    { text: "Quantity", value: "quantity" },
  ];
  promise: Promise<Receipt[]> | null = null;

  @Prop({ default: null }) readonly value!: Receipt[] | null;

  @Watch("value")
  onValueChange(val: Receipt[] | null) {
    if (val) {
      this.promise = new Promise((ok) => ok(val));
    } else this.promise = null;
  }

  mounted(){
    this.onValueChange(this.value);
  }
}
